import { render } from "./OfflineIndicator.vue?vue&type=template&id=18ec67df&scoped=true"
import script from "./OfflineIndicator.vue?vue&type=script&lang=js"
export * from "./OfflineIndicator.vue?vue&type=script&lang=js"

import "./OfflineIndicator.vue?vue&type=style&index=0&id=18ec67df&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18ec67df"]])

export default __exports__